import React from 'react'

const ContentSeparator = ({ children, className }) => (
  <div
    style={{
      display: 'flex',
      padding: 5,
      boxSizing: 'border-box',
      border: '1px solid black',
      justifyContent: 'space-between',
    }}
    className={className}
  >
    {children}
  </div>
)

export { ContentSeparator }
